import React, { Component } from 'react'
import Link, { push } from 'gatsby-link'
import styled from 'styled-components'
import PageTransition from 'gatsby-plugin-page-transitions'
import Slider from 'react-slick'

import Slide from '../components/slide'
import { getIntroSlideshow } from '../components/api'
import '../../assets/fonts'
import '../../node_modules/slick-carousel/slick/slick.css'
import '../../node_modules/slick-carousel/slick/slick-theme.css'

import InstagramIcon from '../../assets/icon/instagram-white.png'
import FacebookIcon from '../../assets/icon/facebook-white.png'

import Responsive from 'react-responsive'

const Mobile = props => <Responsive {...props} maxWidth={767} />
const Desktop = props => <Responsive {...props} minWidth={992} />

const settings = {
  dots: false,
  arrows: false,
  fade: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  lazyLoad: true,
  swipe: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden !important;
`
const NavigationDimmer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 5;
  width: 100vw;
  height: 15vw;
  background: linear-gradient(
    rgba(0, 0, 0, 0.7),
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
`
const NavigationDimmerMobile = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 5;
  width: 100vw;
  height: 35vw;
  background: linear-gradient(
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0)
  );
`
const SliderStyled = styled(Slider)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden !important;
  z-index: 1;
`
class Home extends Component {
  state = {
    slides: [],
    current: 0,
  }

  componentDidMount = () => {
    getIntroSlideshow().then(content => {
      const { slideshow: slides } = content
      this.setState({ slides })
    })
  }

  _navigate = slides => {
    let target = slides[this.state.current].url

    //TODO: fix this
    let location = target.replace('http://www.burlemarx.monographics.org', '')
    push(`${location}${window.location.search}`)
  }

  render() {
    const { slides } = this.state
    return (
      <PageTransition>
        <Wrapper onClick={() => this._navigate(slides)}>
          <SliderStyled
            {...settings}
            afterChange={currentSlide => {
              this.setState({ current: currentSlide })
            }}
          >
            {slides.map((slide, index) => {
              let { image, url } = slide
              // console.log(image, url)
              return (
                <div>
                  <Slide image={image} url={url} key={index} />
                </div>
              )
            })}
          </SliderStyled>
          <Desktop>
            <NavigationDimmer />
          </Desktop>
          <Mobile>
            <NavigationDimmerMobile />
          </Mobile>
          <Desktop>
            <div
              style={{
                position: `absolute`,
                left: `5vw`,
                zIndex: 5,
                bottom: `2vh`,
              }}
            >
              <img
                src={InstagramIcon}
                style={{
                  width: '41px',
                  height: '41px',
                  zIndex: 5,
                  marginTop: `20px`,
                }}
                onClick={() =>
                  window.open(
                    'https://www.instagram.com/escritorioburlemarx/',
                    '_blank'
                  )
                }
              />
              <img
                src={FacebookIcon}
                style={{
                  width: '41px',
                  height: '41px',
                  marginLeft: '20px',
                }}
                onClick={() =>
                  window.open(
                    'https://www.facebook.com/escritorioburlemarx/',
                    '_blank'
                  )
                }
              />
            </div>
          </Desktop>
          <Mobile>
            <div
              style={{
                position: `fixed`,
                left: `10vw`,
                bottom: `2vh`,
                zIndex: 5,
              }}
            >
              <img
                src={InstagramIcon}
                style={{ width: '41px', height: '41px', marginTop: `20px` }}
                onClick={() =>
                  window.open(
                    'https://www.instagram.com/escritorioburlemarx/',
                    '_blank'
                  )
                }
              />
              <img
                src={FacebookIcon}
                style={{
                  width: '41px',
                  height: '41px',
                  marginLeft: '20px',
                }}
                onClick={() =>
                  window.open(
                    'https://www.facebook.com/escritorioburlemarx/',
                    '_blank'
                  )
                }
              />
            </div>
          </Mobile>
        </Wrapper>
        {/* mudando um pouco de assunto. semana que vem, onde estaremos sem filhos, tava pensando em dar uma volta pelas expos novas. ir no IMS e na Casa Firjan, nesse ultimo, por conta de conhecer mesmo e ver o que os adversarios fizeram */}
      </PageTransition>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/index.js